import LoadingSkeleton from "./loading_skeleton.tsx";
import { SecondaryBody } from "@sprout/typography.tsx";
import useTranslation from "@hooks/use_translation.ts";
import { useTimeAgo, composeStatusLabel } from "@utils/time_ago";

type Props = {
  loading?: boolean;
  publishedAt: string;
  viewed: boolean;
  appliedAt: string | null;
};

const Footer = ({ loading, publishedAt, viewed, appliedAt }: Props) => {
  const { t } = useTranslation("jobSearch");
  const postedLabel = composeStatusLabel(t("posted"), useTimeAgo(publishedAt));
  const appliedLabel = composeStatusLabel(t("applied"), useTimeAgo(appliedAt ?? ""));

  return loading ? (
    <LoadingSkeleton className="h-4 w-[80px]" />
  ) : (
    <SecondaryBody>
      {postedLabel}
      {appliedAt && ` • ${appliedLabel}`}
      {viewed && !appliedAt && ` • ${t("viewed")}`}
    </SecondaryBody>
  );
};

export default Footer;
